import { get } from './axios.js'

let api = '/api'

export const getColumnInfo = query => get(api + '/getColumnDetail?' + (query || ''))
export const getColumnNews = query => get(api + '/getArticleList?' + (query || ''))
